module.exports = __webpack_public_path__ + "images/emoji/shoe.26ba114702e45d24c376.png";